import {
  API_TYPES,
  RequirementWorkflowType,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";

import { type WorkerRequirement } from "../../../api/types";

interface MiscRequirementData {
  requirementId: string;
  qualifications: string[];
  instructions: string;
}

export const createMiscWorkerRequirement = (props: MiscRequirementData): WorkerRequirement => ({
  ...props,
  status: WorkerRequirementStatus.MISSING,
  isValid: false,
  requirement: {
    type: API_TYPES.requirements,
    id: props.requirementId,
    attributes: {
      name: "Miscellaneous Document",
      instructions: props.instructions,
      requirementWorkflowType: RequirementWorkflowType.MISCELLANEOUS,
    },
  },
  documents: [],
});
